export function isUUID(uuid: string) {
  const s = `${uuid}`;
  const match = s.match(
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
  );
  if (match === null) {
    return false;
  }
  return true;
}
export const emptyUUID = '00000000-0000-0000-0000-000000000000' as const;
